module.exports = "https://cdn.realtymogul.com/static/media/multifamily_strategy2.d9c2b457.jpg";